import type { AppPageTab } from '@/components/shell/AppPage/app-page-types'

import {
  identityTabs,
  inboxTabs,
  mediaTabs,
  settingsTabs,
  strategyTabs,
  styleTabs,
  visibilityTabs,
} from './page-tabs'

/** The tabbed sections of the app; each is one route with a persistent header and one child route per tab. */
export type SectionId =
  | 'inbox'
  | 'strategy'
  | 'media'
  | 'visibility'
  | 'identity'
  | 'style'
  | 'settings'

/** What a section layout shows in its header, independent of the active tab. */
export interface SectionConfig {
  /** i18n key of the section's title, shown on the top line. */
  titleKey: string
  /** i18n key of the tab bar's accessible name. */
  tabsAriaKey: string
  tabs: (t: (key: string) => string) => AppPageTab[]
  /** The body fills the page below the pinned header and owns its scrolling. */
  fullHeight?: boolean
}

export const SECTIONS: Readonly<Record<SectionId, SectionConfig>> = {
  inbox: {
    titleKey: 'nav.inbox',
    tabsAriaKey: 'inbox.tabsAria',
    tabs: inboxTabs,
    fullHeight: true,
  },
  strategy: { titleKey: 'nav.strategy', tabsAriaKey: 'nav.strategy', tabs: strategyTabs },
  media: { titleKey: 'nav.media', tabsAriaKey: 'media.typeAriaLabel', tabs: mediaTabs },
  visibility: { titleKey: 'nav.visibility', tabsAriaKey: 'nav.visibility', tabs: visibilityTabs },
  identity: { titleKey: 'nav.profile', tabsAriaKey: 'nav.profile', tabs: identityTabs },
  style: { titleKey: 'nav.style', tabsAriaKey: 'nav.style', tabs: styleTabs },
  settings: { titleKey: 'nav.settings', tabsAriaKey: 'nav.settings', tabs: settingsTabs },
}
